module.exports = __webpack_public_path__ + "img/组 185.415298a1.png";